<script lang="ts">
    import "../../app.css";
    import {token, user} from "$lib/stores/auth";
    import {currentCustomer, userCustomer} from "$lib/stores/customer";
    import {PUBLIC_AUTH_ENDPOINT, PUBLIC_APP_BASE} from "$env/static/public";
    import {page} from '$app/stores';
    import {get} from "$lib/api";
    import {fullCustomer} from "$lib/calls/customer";
    import {sideMenuEnabled} from "$lib/stores/menus";
    import {Banner, Button, Heading, Input, Label, Modal} from "flowbite-svelte";
    import NavAuthor from "$lib/components/hexadash/NavAuthor.svelte";
    import Sidebar from "$lib/partials/Sidebar.svelte";
    import "iconify-icon";
    import {AdjustmentsHorizontalSolid, IconSolid} from "flowbite-svelte-icons";
    import {currentRoute} from "$lib/stores/route";

    export let data :{claim: any};





    token.subscribe(val => {
        if (!val && typeof window !== 'undefined') {
            window.location = PUBLIC_AUTH_ENDPOINT + `?redirect=${window.location.origin}`
        } else if (typeof window !== 'undefined') {
            user.set(data.claim)
            get('/auth/me').then(res => {
                if(!$userCustomer) {
                    userCustomer.set(res.associations[0].customer)
                }
                if(!$currentCustomer){
                    currentCustomer.set(res.associations[0].customer)
                }
            })
        }
    })


    // user in global layout!

    // customer
    let localCustomer = null;
    userCustomer.subscribe(async val => {
        if (val) {
            localCustomer = await fullCustomer(val.uuid)
        }

    })
    let displayMenuText = $sideMenuEnabled;
</script>

<Banner bannerType="info" dismissable={false}>
    <div slot="header">
        <div class="flex gap-5">
            <nav class="min-w-[245px] flex gap-3 items-center pl-2">
                <a class="block max-w-max" href="/">
                    <img src="https://apps.demo.celest.rest/auth/logo.jpeg" class="max-h-12 w-12" alt="">
                </a>
                <NavAuthor/>
            </nav>
            <Heading tag="h1" customSize="text-2xl" class="flex gap-3 items-center pl-4 text-neutral-600">
                {#if $currentRoute}
                <IconSolid icon={$currentRoute.icon}/>
                {/if}
                {$page.data.page_title || $currentRoute?.label}
            </Heading>
        </div>
    </div>


</Banner>


<main class="main-content flex flex-1">
    <div class="{$sideMenuEnabled ? 'w-[280px]' : ''}">
        <div class="grid px-3 mt-4">
            <Button size="xs" color="alternative" on:click={() => $sideMenuEnabled = !$sideMenuEnabled}>
                <IconSolid icon={AdjustmentsHorizontalSolid} size="xs"/>
            </Button>
        </div>
        <Sidebar bind:displayMenuText={$sideMenuEnabled}/>
    </div>

    <div class="flex-1 pt-3 mb-5 px-4">

        <slot/>
    </div>
</main>




